module.exports = "<div ng-hide=\"$ctrl.empty\" id=\"map\" style=\"height: 680px; width: 100%;\"></div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/map/map.html
// module id = 47
// module chunks = 3